import { api } from "../api";
import { validatePassword, mountPasswordChecklist } from "../utils/validation";
import { esc } from "../utils/html";

let step = 1;

let orgData = {
  name: "",
  category: "PRAXIS" as "PRAXIS" | "KRANKENHAUS",
  street: "",
  house_no: "",
  plz: "",
  ort: "",
  email: "",
  phone: "",
  contact_person: "",
};

export async function render(el: HTMLElement) {
  step = 1;
  renderStep(el);
}

function renderStepper(): string {
  return `<div class="register-stepper">
    <div class="register-step ${step >= 1 ? "active" : ""} ${step > 1 ? "done" : ""}">
      <div class="step-number">${step > 1 ? "&#10003;" : "1"}</div>
      <div class="step-label">Einrichtung</div>
    </div>
    <div class="step-line ${step > 1 ? "done" : ""}"></div>
    <div class="register-step ${step >= 2 ? "active" : ""} ${step > 2 ? "done" : ""}">
      <div class="step-number">${step > 2 ? "&#10003;" : "2"}</div>
      <div class="step-label">Benutzer</div>
    </div>
    <div class="step-line ${step > 2 ? "done" : ""}"></div>
    <div class="register-step ${step >= 3 ? "active" : ""}">
      <div class="step-number">&#10003;</div>
      <div class="step-label">Fertig</div>
    </div>
  </div>`;
}

function renderStep(el: HTMLElement, code?: string, email?: string) {
  if (step === 1) renderStep1(el);
  else if (step === 2) renderStep2(el);
  else renderSuccess(el, code, email);
}

function renderStep1(el: HTMLElement) {
  el.innerHTML = `
    <div class="register-screen">
      <div class="register-card">
        <img src="Logo.png" alt="Meduvio Logo" class="login-logo">
        <h1>Meduvio</h1>
        <p class="register-subtitle">Registrierung als Praktikumsstelle</p>
        ${renderStepper()}
        <div class="register-form">
          <h2>Einrichtung</h2>
          <div class="form-group"><label>Name der Einrichtung *</label><input id="r-name" value="${esc(orgData.name)}" placeholder="z.B. Physiotherapie Mustermann" /></div>
          <div class="form-group">
            <label>Art *</label>
            <select id="r-category">
              <option value="PRAXIS" ${orgData.category === "PRAXIS" ? "selected" : ""}>Praxis</option>
              <option value="KRANKENHAUS" ${orgData.category === "KRANKENHAUS" ? "selected" : ""}>Krankenhaus</option>
            </select>
          </div>
          <div class="form-grid">
            <div class="form-group"><label>Stra&szlig;e</label><input id="r-street" value="${esc(orgData.street)}" placeholder="Musterstra&szlig;e" /></div>
            <div class="form-group"><label>Hausnummer</label><input id="r-house" value="${esc(orgData.house_no)}" placeholder="12a" /></div>
          </div>
          <div class="form-grid">
            <div class="form-group"><label>PLZ *</label><input id="r-plz" value="${esc(orgData.plz)}" maxlength="5" placeholder="12345" /></div>
            <div class="form-group"><label>Ort *</label><input id="r-ort" value="${esc(orgData.ort)}" placeholder="Berlin" /></div>
          </div>
          <div class="form-group"><label>E-Mail der Einrichtung *</label><input id="r-org-email" type="email" value="${esc(orgData.email)}" placeholder="info@praxis.de" /></div>
          <div class="form-group"><label>Telefon</label><input id="r-phone" value="${esc(orgData.phone)}" placeholder="030 12345678" /></div>
          <div class="form-group"><label>Ansprechpartner:in</label><input id="r-contact" value="${esc(orgData.contact_person)}" placeholder="Vor- und Nachname" /></div>
          <div id="r-error" class="register-error hidden"></div>
          <div class="form-actions" style="justify-content:flex-end">
            <button class="btn btn-primary" id="r-next">Weiter</button>
          </div>
        </div>
        <a href="#/" class="register-back">Zur&uuml;ck zur Anmeldung</a>
      </div>
    </div>`;

  el.querySelector("#r-next")!.addEventListener("click", () => {
    const name = (el.querySelector("#r-name") as HTMLInputElement).value.trim();
    const category = (el.querySelector("#r-category") as HTMLSelectElement).value as "PRAXIS" | "KRANKENHAUS";
    const street = (el.querySelector("#r-street") as HTMLInputElement).value.trim();
    const house_no = (el.querySelector("#r-house") as HTMLInputElement).value.trim();
    const plz = (el.querySelector("#r-plz") as HTMLInputElement).value.trim();
    const ort = (el.querySelector("#r-ort") as HTMLInputElement).value.trim();
    const email = (el.querySelector("#r-org-email") as HTMLInputElement).value.trim();
    const phone = (el.querySelector("#r-phone") as HTMLInputElement).value.trim();
    const contact_person = (el.querySelector("#r-contact") as HTMLInputElement).value.trim();

    const errEl = el.querySelector("#r-error")!;
    if (!name || !plz || !ort || !email) {
      errEl.textContent = "Bitte fülle alle Pflichtfelder aus.";
      errEl.classList.remove("hidden");
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      errEl.textContent = "Bitte gib eine gültige E-Mail-Adresse ein.";
      errEl.classList.remove("hidden");
      return;
    }

    orgData = { name, category, street, house_no, plz, ort, email, phone, contact_person };
    step = 2;
    renderStep(el);
  });
}

function renderStep2(el: HTMLElement) {
  el.innerHTML = `
    <div class="register-screen">
      <div class="register-card">
        <img src="Logo.png" alt="Meduvio Logo" class="login-logo">
        <h1>Meduvio</h1>
        <p class="register-subtitle">Registrierung als Praktikumsstelle</p>
        ${renderStepper()}
        <div class="register-form">
          <h2>Dein Benutzerkonto</h2>
          <div class="form-grid">
            <div class="form-group"><label>Vorname *</label><input id="r-firstname" placeholder="Max" /></div>
            <div class="form-group"><label>Nachname *</label><input id="r-lastname" placeholder="Mustermann" /></div>
          </div>
          <div class="form-group"><label>E-Mail-Adresse *</label><input id="r-email" type="email" placeholder="max@praxis.de" /></div>
          <div class="form-group"><label>Passwort *</label><input id="r-password" type="password" /><ul id="r-pw-checklist" class="pw-checklist"></ul></div>
          <div class="form-group"><label>Passwort best&auml;tigen *</label><input id="r-password2" type="password" /></div>
          <div class="form-group consent-group">
            <label class="checkbox-label">
              <input type="checkbox" id="r-agb">
              <span>Ich akzeptiere die <a href="#/agb" target="_blank" class="link-btn">Allgemeinen Gesch&auml;ftsbedingungen (AGB)</a></span>
            </label>
          </div>
          <div class="form-group consent-group">
            <label class="checkbox-label">
              <input type="checkbox" id="r-avv">
              <span>Ich stimme der <a href="#/avv-praktikumsstelle" target="_blank" class="link-btn">Auftragsverarbeitungsvereinbarung (AVV)</a> gem&auml;&szlig; Art.&nbsp;28&nbsp;DS-GVO zu</span>
            </label>
          </div>
          <div id="r-error" class="register-error hidden"></div>
          <div class="form-actions">
            <button class="btn btn-secondary" id="r-back">Zur&uuml;ck</button>
            <button class="btn btn-primary" id="r-submit">Registrieren</button>
          </div>
        </div>
        <a href="#/" class="register-back">Zur&uuml;ck zur Anmeldung</a>
      </div>
    </div>`;

  el.querySelector("#r-back")!.addEventListener("click", () => { step = 1; renderStep(el); });
  el.querySelector("#r-submit")!.addEventListener("click", () => submitRegistration(el));
  mountPasswordChecklist(el.querySelector("#r-password")!, el.querySelector("#r-pw-checklist")!);
}

async function submitRegistration(el: HTMLElement) {
  const firstName = (el.querySelector("#r-firstname") as HTMLInputElement).value.trim();
  const lastName = (el.querySelector("#r-lastname") as HTMLInputElement).value.trim();
  const email = (el.querySelector("#r-email") as HTMLInputElement).value.trim();
  const password = (el.querySelector("#r-password") as HTMLInputElement).value;
  const password2 = (el.querySelector("#r-password2") as HTMLInputElement).value;
  const agbAccepted = (el.querySelector("#r-agb") as HTMLInputElement).checked;
  const avvAccepted = (el.querySelector("#r-avv") as HTMLInputElement).checked;

  const errEl = el.querySelector("#r-error")!;
  if (!firstName || !lastName || !email || !password) {
    errEl.textContent = "Bitte fülle alle Pflichtfelder aus.";
    errEl.classList.remove("hidden"); return;
  }
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    errEl.textContent = "Bitte gib eine gültige E-Mail-Adresse ein.";
    errEl.classList.remove("hidden"); return;
  }
  const pwErr = validatePassword(password);
  if (pwErr) {
    errEl.textContent = pwErr;
    errEl.classList.remove("hidden"); return;
  }
  if (password !== password2) {
    errEl.textContent = "Die Passwörter stimmen nicht überein.";
    errEl.classList.remove("hidden"); return;
  }
  if (!agbAccepted) {
    errEl.textContent = "Bitte akzeptiere die Allgemeinen Geschäftsbedingungen.";
    errEl.classList.remove("hidden"); return;
  }
  if (!avvAccepted) {
    errEl.textContent = "Bitte stimme der Auftragsverarbeitungsvereinbarung zu.";
    errEl.classList.remove("hidden"); return;
  }

  const submitBtn = el.querySelector("#r-submit") as HTMLButtonElement;
  submitBtn.disabled = true;
  submitBtn.textContent = "Wird registriert…";
  errEl.classList.add("hidden");

  try {
    const result = await api.registerPractice.submit({
      organization: orgData,
      user: { firstName, lastName, email, password },
      agbAccepted: true,
      avvAccepted: true,
    });
    step = 3;
    renderStep(el, result.code, email);
  } catch (err: any) {
    errEl.textContent = err.message || "Registrierung fehlgeschlagen.";
    errEl.classList.remove("hidden");
    submitBtn.disabled = false;
    submitBtn.textContent = "Registrieren";
  }
}

function renderSuccess(el: HTMLElement, code?: string, email?: string) {
  el.innerHTML = `
    <div class="register-screen">
      <div class="register-card">
        <img src="Logo.png" alt="Meduvio Logo" class="login-logo">
        <h1>Meduvio</h1>
        <p class="register-subtitle">Registrierung als Praktikumsstelle</p>
        ${renderStepper()}
        <div class="register-form register-success">
          <div class="success-icon">&#10004;</div>
          <h2>Registrierung erfolgreich!</h2>
          <p>Beim ersten Anmelden wirst du aufgefordert, deine E-Mail-Adresse zu best&auml;tigen.</p>
          <p>Ein Best&auml;tigungslink wird dann an${email ? ` <strong>${esc(email)}</strong>` : " deine E-Mail-Adresse"} gesendet.</p>
          ${code ? `
            <div class="practice-code-box">
              <div class="practice-code-label">Dein Einrichtungs-Code</div>
              <div class="practice-code-value">${esc(code)}</div>
              <p class="practice-code-hint">Gib diesen Code an Schulen weiter, bei denen du als Einrichtung tätig bist.
              Die Schule kann dich damit mit ihrer Planung verknüpfen.</p>
            </div>` : ""}
          <div class="form-actions" style="justify-content:center;margin-top:1.5rem">
            <a href="#/" class="btn btn-primary">Zur Anmeldung</a>
          </div>
        </div>
      </div>
    </div>`;
}
